import { FC } from 'react';
import { AvatarTextSkeleton } from 'components/Shared/AvatarText/Skeleton';
import type { NftAvatarBlockProps } from './';

export const NftAvatarBlockSkeleton: FC<NftAvatarBlockProps> = ({
  size = 'medium',
  showAvatar
}) => {
  return (
    <AvatarTextSkeleton
      text=""
      size={size}
      shape="circle"
      showAvatar={showAvatar}
    />
  );
};
